import {
  secureGet, securePost, securePut, secureDelete,
} from 'config/apiConfig';

export const defaultMessage = 'Erreur système';

export const getAnnouncements = async ({
  page = 0, size = 10, sort = 'startDate,desc', type = '', startDate = '', endDate = '',
}, search) => {
  const params = new URLSearchParams({ page, size, sort });
  if (search) params.set('search', search);
  if (type) params.set('type', type);
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  const { data } = await secureGet(`/announcements?${params.toString()}`);
  return data;
};

export const addAttachement = async (file) => {
  const bodyFormData = new FormData();
  bodyFormData.set('file', file);
  const token = localStorage.getItem('token');
  const { data } = await securePost('/attachments/announcement/add', bodyFormData, {
    headers: { Authorization: `Bearer ${token}` },
  }, false);
  return data;
};

export const addAnnouncements = async (announce) => {
  const body = {
    ...announce,
    fileEvent: announce.fileEvent?.length === 0 ? null : announce.fileEvent,
    imageEvent: announce.imageEvent?.length === 0 ? null : announce.imageEvent,
  };
  console.log('[addAnnouncement] payload:', JSON.stringify(body, null, 2));
  const { data } = await securePut('/announcements/add', body);
  return data;
};

export const deleteAnnouncements = async (id) => {
  await secureDelete(`/announcements/delete/${id}`);
  return true;
};
